var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "link-btn"
  }, [_c('div', [_vm._t("default")], 2), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/z-3.png"),
      "alt": "z"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };